import Vue from 'vue'
import VueRouter from 'vue-router'
import { Toast } from 'vant'

Vue.use(VueRouter)

function loadPage(pageName) {
    return () => import(/* webpackChunkName: "[request]" */ `@/views/${pageName}`)
}

const routes = [
    {
        path: '/',
        name: 'Home',
        component: loadPage('Home'),
        // redirect: '/login',
        children: [
            {
                path: '/login',
                name: 'Login',
                component: loadPage('Login'),
                meta: {
                    title: '登录',
                },
            },
            {
                path: '/resetPassword',
                name: 'ResetPassword',
                component: loadPage('ResetPassword'),
                meta: {
                    title: '找回密码',
                },
            },
            {
                path: '/register',
                name: 'Register',
                component: loadPage('Register'),
                meta: {
                    title: '注册',
                },
            },
            {
                path: '/bindMobile',
                name: 'BindMobile',
                component: loadPage('BindMobile'),
                meta: {
                    title: '绑定邮箱',
                },
            },
            {
                path: '/bindIdCard',
                name: 'BindIdCard',
                component: loadPage('BindIdCard'),
                meta: {
                    title: '实名认证',
                },
            },
            {
                path: '/userCenter',
                name: 'UserCenter',
                component: loadPage('UserCenter'),
                meta: {
                    title: '用户中心',
                },
            },
            {
                path: '/couponList',
                name: 'CouponList',
                component: loadPage('CouponList'),
                meta: {
                    title: '优惠券列表',
                },
            },
        ],
    },
    {
        path: '/redirect',
        name: 'Redirect',
        component: loadPage('Redirect'),
    },
    {
        path: '/chargeCenter',
        name: 'ChargeCenter',
        component: loadPage('ChargeCenter'),
        meta: {
            title: '充值中心',
        },
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
})

let toast = null

router.beforeEach((to, from, next) => {
    toast = Toast.loading({
        forbidClick: true,
        loadingType: 'spinner',
        message: '加载中...',
        duration: 5000,
    })
    next()
})
router.afterEach(() => {
    toast && toast.clear()
})
export default router
